import { createFileRoute } from '@tanstack/react-router';

import { Button, ButtonGroup } from '@/common/components/button';
import { Heading, Subheading } from '@/common/components/heading';

export const Route = createFileRoute(
  '/applications/$application-id/service-location/confirm'
)({
  component: ConfirmServiceLocationComponent
});

function ConfirmServiceLocationComponent() {
  return (
    <div className="p-8">
      <Heading>Confirm Service Location</Heading>

      <Subheading>Connect Date</Subheading>
      <p>Connection requested for service starting on <strong>7/4/2025</strong>.</p>
      <p><em>*Same day connection is not guaranteed.</em></p>

      <Subheading>Service Address</Subheading>
      <p>
        4500 Natural Bridge Rd<br/>
        Tallahassee,FL 32305
      </p>

      <ButtonGroup>
        <Button to="/applications/$application-id/service-location" params={{ 'application-id': '1' }} outline>Back</Button>
        <Button to="/applications/$application-id/consent" params={{ 'application-id': '1' }}>Next</Button>
      </ButtonGroup>
    </div>
  );
}
